import React, { type JSX } from 'react';
import { NodeUrvalType } from '../../../../../../Types/UrvalTypes';
import { ApolloError } from '@apollo/client';
import query from './NodeUrvalQuery.gql';
import { Query } from '@apollo/client/react/components';
import {
  NodeUrvalQuery as INodeUrvalQueryData,
  NodeUrvalQueryVariables as INodeUrvalQueryVariables,
} from './_QueryTypes/NodeUrvalQuery';

interface IUrvalQueryResult {
  loading: boolean;
  error?: ApolloError | Error;
  urval?: NodeUrvalType;
}

interface IProps {
  children: (urvalQueryResult: IUrvalQueryResult) => JSX.Element | null;
  id?: string;
  useCache?: boolean;
}

class UrvalQuery extends React.Component<IProps> {
  render() {
    return (
      <Query<INodeUrvalQueryData, INodeUrvalQueryVariables>
        query={query}
        variables={{
          id: this.props.id || '',
        }}
        skip={this.props.id == null}
        fetchPolicy={!this.props.useCache ? 'network-only' : undefined}
      >
        {({ loading, error, data }) => {
          const urval =
            data != null &&
            data.node != null &&
            data.node.__typename === 'TEDSelection'
              ? data.node
              : undefined;

          return this.props.children({
            loading,
            error,
            urval,
          });
        }}
      </Query>
    );
  }
}

export default UrvalQuery;
